import { Log } from '../AuxillaryService/Log';
import { Scheduler } from '../Utility/Scheduler';
import * as COM from '../Platform/COM';
import { $ } from '../../vendor/jquery';
import { moment } from '../../vendor/moment';
import { switchDisplay } from './DisplaySwitching';

/**
 *
 * @class
 * @param {*} sch
 * @param {*} comPort
 * @param {*} displayMake
 * @todo document this
 */
function StreamSchedule(sch, comPort, displayMake) {
    var no_displays_html =
        '<div class="no-displays-to-show" style="width:100%;height:100%;vertical-align:middle; text-align:center;position:absolute;background-color:#000;color:#FFF;font-family:Arial;font-size:26px;">';
    no_displays_html +=
        '<div style="position:relative;top: 50%;transform: translateY(-50%);width:100%;"><div>No content is currently scheduled for this media player.</div></div>';
    no_displays_html += '</div>';
    var t = this;
    t.currently_visible_display = null;
    t.stream_timeout = null;
    t.stream_parts_order = 1;

    t.total_displays = function () {
        var uniqueidarray = [];
        var uniqueobjarray = [];
        sch.forEach(function (s) {
            if (s.display_id <= 0 && s.parts.length > 0) {
                //if schedule contains parts
                s.parts.forEach(function (p) {
                    if ($.inArray(p.displays_id, uniqueidarray) === -1) {
                        //get unigue id's
                        var id = parseInt(p.displays_id);
                        uniqueidarray.push(id);
                    }
                });

                window['stream_schedule_' + s.id] = [s];
                uniqueobjarray.push(window['stream_schedule_' + s.id]);
            } else if ($.inArray(s.display_id, uniqueidarray) === -1) {
                //no parts, display id is not in unique array
                window['stream_schedule_' + s.display_id] = [s];
                uniqueobjarray.push(window['stream_schedule_' + s.display_id]);
                uniqueidarray.push(s.display_id);
            } else {
                window['stream_schedule_' + s.display_id] = [s];
                uniqueobjarray.push(window['stream_schedule_' + s.display_id]);
                //window["stream_schedule_" + s.display_id].push(s);
            }
        });

        return uniqueobjarray;
    };

    t.resolve_display = async function () {
        var display_to_play = null;
        t.unique_displays = t.total_displays();

        var m = moment();
        var day_of_week = m.format('dddd');

        var displays_on_this_day = [];

        t.unique_displays.forEach(function (ds) {
            ds.forEach(function (dsp) {
                if (dsp[day_of_week.toLowerCase()] === true) {
                    displays_on_this_day.push(dsp);
                }
            });
        });

        if (displays_on_this_day.length > 0) {
            //at least one display exists
            displays_on_this_day.forEach(function (dotd) {
                var startMoment = timeStringToMoment(dotd.start_hour);
                var endMoment = timeStringToMoment(dotd.end_time);
                if (moment().isBetween(startMoment, endMoment)) {
                    display_to_play = dotd;
                }
            });
        }

        // set variables needed for start events and end events
        var rs232Instance = null;
        var fetchRs232Instance = function () {
            if (!rs232Instance) {
                if (!comPort || !displayMake) {
                    // user did not properly set up the com configuration for
                    // this player
                    console.error(
                        'Invalid COM configuration. Either comPort or displayMake is empty!'
                    );
                    return;
                }
                rs232Instance = COM.Rs232Display.createOrOpen(comPort, displayMake);
            }
        };

        /**
         * may return before all of the commands in commandList are finished
         * running (returns Promise)
         * @param commandList
         * @param currentIndex
         * @param eventTrigger
         * @return {Promise}
         */
        var runNextSetOfCommands = function (
            commandList,
            currentIndex,
            eventTrigger,
            resolveOriginal
        ) {
            return new Promise(function (resolve) {
                if (resolveOriginal) {
                    resolve = resolveOriginal;
                }

                for (var i in commandList) {
                    if (parseInt(i) < currentIndex) {
                        continue;
                    }

                    var command = commandList[i];
                    if (command.event_trigger == eventTrigger) {
                        try {
                            if (command.command.indexOf('rs232Instance') > -1) {
                                fetchRs232Instance();
                            }
                            var evalResult = eval(command.command);
                            if (evalResult && (evalResult.catch || evalResult.always)) {
                                // check if the return is a Promise or jQuery-style promise
                                if (evalResult.catch) {
                                    evalResult
                                        .then(function () {
                                            runNextSetOfCommands(
                                                commandList,
                                                parseInt(i) + 1,
                                                eventTrigger,
                                                resolve
                                            );
                                        })
                                        .catch(function (error) {
                                            console.error(
                                                'Promise error was caught. Command: ' +
                                                    command.command,
                                                error
                                            );
                                            runNextSetOfCommands(
                                                commandList,
                                                parseInt(i) + 1,
                                                eventTrigger,
                                                resolve
                                            );
                                        });
                                } else {
                                    // jQuery-style promise
                                    evalResult.then(
                                        function () {
                                            runNextSetOfCommands(
                                                commandList,
                                                parseInt(i) + 1,
                                                eventTrigger,
                                                resolve
                                            );
                                        },
                                        function (error) {
                                            console.error(
                                                'Promise error was caught. Command: ' +
                                                    command.command,
                                                error
                                            );
                                            runNextSetOfCommands(
                                                commandList,
                                                parseInt(i) + 1,
                                                eventTrigger,
                                                resolve
                                            );
                                        }
                                    );
                                }
                                return;
                            }
                        } catch (error1) {
                            console.error(error1);
                        }
                    }

                    currentIndex++;
                }

                resolve();
            });
        };
        var endCommandsPromise = new Promise(function (resolve) {
            // just in case there is no current display to run end commands
            resolve();
        });

        // run the end event commands for the display that is ending
        if (
            display_to_play !== t.currently_visible_display &&
            t.currently_visible_display &&
            t.currently_visible_display.commands
        ) {
            endCommandsPromise = runNextSetOfCommands(
                t.currently_visible_display.commands,
                0,
                'End'
            );
            // either current display is ending all together (no more
            // scheduled), or if display_to_play is not null, then another
            // display will take it's place
            t.currently_visible_display = null;
        }

        if (!display_to_play) {
            //no display to play during this time
            //console.log("No Display to play at this time");
            if ($('.no-displays-to-show').length == 0) {
                Log.Info('No Display to play at this time', null, __fileline);
                $('body').append(no_displays_html);
            }
        } else {
            //console.log('Display Found!', display_to_play);
            $('.no-displays-to-show').remove();
            if (display_to_play !== t.currently_visible_display) {
                // switching to another schedule element/display on the stream
                // schedule

                // run the start event commands for the display that is starting
                if (display_to_play.commands) {
                    endCommandsPromise.then(function () {
                        runNextSetOfCommands(display_to_play.commands, 0, 'Start');
                    });
                }

                t.currently_visible_display = display_to_play;
                if (t.stream_timeout !== null) {
                    clearTimeout(t.stream_timeout);
                    t.stream_timeout = null;
                }

                if (display_to_play.display_id > 0) {
                    t.stream_parts_order = 1;
                    await switchDisplay(parseInt(display_to_play.display_id));
                } else {
                    t.run_stream_intervals(display_to_play);
                }
            }
        }
    };

    /**
     * Runs stream schedule displays_id is null, meaning their are multiple
     * parts or display elements tied to this stream_schedule. And the stream
     * will alternate based on their duration
     * @param display_to_play
     */
    t.run_stream_intervals = function (display_to_play) {
        if (display_to_play.parts[t.stream_parts_order - 1]) {
            display_to_play.parts.forEach(async function (part) {
                if (part.order == t.stream_parts_order) {
                    await switchDisplay(parseInt(part.displays_id));

                    t.stream_timeout = setTimeout(function () {
                        t.run_stream_intervals(display_to_play);
                    }, parseInt(part.duration * 1000));
                }
            });
            t.stream_parts_order++;
        } else {
            t.stream_parts_order = 1;
            t.run_stream_intervals(display_to_play);
        }
    };

    /**
     * Takes a string formatted like '00:00:00' (any delimiter okay) and returns
     * a moment object
     *
     * Attempts to format strings with any delimiter and with variable time
     * components
     * @param {string} timeString
     * @return {Moment}
     */
    function timeStringToMoment(timeString) {
        var timeRegex = /[0-9]+/g;
        var timeStringMatches = timeString.match(timeRegex); //start_hour and end_time are strings formatted like 00:00:00
        var hours = parseInt(timeStringMatches[0] || 0);
        var minutes = parseInt(timeStringMatches[1] || 0);
        var seconds = parseInt(timeStringMatches[2] || 0);

        return moment().hour(hours).minute(minutes).second(seconds);
    }

    Scheduler.New().Called('resolve_display').HasAction(t.resolve_display).RunEvery(10, 'seconds');
}

/**
 *
 * @param {*} sch
 * @param {*} comPort
 * @param {*} displayMake
 * @returns {StreamSchedule}
 */
export function createStreamSchedule(sch, comPort, displayMake) {
    return new StreamSchedule(sch, comPort, displayMake);
}
